import { ConfirmInvitationPayload } from 'app/api/confirmInvitation'
import { SignupPayload } from 'app/api/signup'
import * as Yup from 'yup'
import { AnyObjectSchema } from 'yup'

export type SignupFormData = {
  email: string
  password: string
  passwordConfirmation: string
}

export const defaultValues = (email?: string): SignupFormData => {
  return {
    email: email || '',
    password: '',
    passwordConfirmation: '',
  }
}

export const validationSchema = (isInvitation?: boolean): AnyObjectSchema =>
  Yup.object().shape({
    email: Yup.string().when([], {
      is: () => !isInvitation,
      then: Yup.string()
        .email('Formato non valido')
        .required('Campo obbligatorio'),
    }),
    // strong regex: 1 uppercase, 1 lowercase, 1 number, 1 special, min length 8
    password: Yup.string()
      .required('Campo obbligatorio')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*?/=:;£"_\-'])(?=.{8,})/,
        'La password non soddisfa i requisiti'
      ),
    passwordConfirmation: Yup.string().oneOf(
      [Yup.ref('password'), null],
      'La password deve coincidere'
    ),
  })

export const adaptFormDataToSignupAPI = (
  formData: SignupFormData
): SignupPayload => ({
  api_v1_user: {
    email: formData.email,
    password: formData.password,
    password_confirmation: formData.passwordConfirmation,
  },
})

export const adaptFormDataToInvitationAPI = (
  formData: SignupFormData,
  invitation_token: string
): ConfirmInvitationPayload => ({
  api_v1_user: {
    invitation_token: invitation_token,
    // email: Skip email on invitation, is not needed
    password: formData.password,
    password_confirmation: formData.passwordConfirmation,
  },
})
